import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid } from "recharts";
import { LINE_CHART_DATA } from "../../../../../../data/rhsAssessmentData";

export default function CustomLineChart() {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <LineChart
        width={500}
        height={200}
        data={LINE_CHART_DATA}
      >
        <CartesianGrid vertical={false} />
        <XAxis dataKey="key" />
        <YAxis strokeWidth={0} />
        <Line type="monotone" dataKey="values_1" dot={false} stroke="#444CE7" />
      </LineChart>
    </ResponsiveContainer>
  );
}